import { whitelabelsStore } from '@/stores/whitelabels'
import { useMediaQuery } from '@vueuse/core'

export const useWhitelabelsStyles = (partnerKey) => {
	const whitelabels = whitelabelsStore()
	const route = useRoute()

	// Determine the active partnerKey
	const activePartnerKey = computed(() => {
		if (partnerKey) return partnerKey
		if (route.path.includes('auroraenergy')) return 'auroraenergy'
		if (route.path.includes('sonnendrive')) return 'sonnendrive'
		return ''
	})

	// Return corresponding styles
	const whitelabel = computed(() => {
		switch (activePartnerKey.value) {
			case 'auroraenergy':
				return whitelabels.getAuroraEnergyStyles
			case 'sonnendrive':
				return whitelabels.getSonnenDriveStyles
			default:
				return {}
		}
	})

	return { whitelabel, partnerName: activePartnerKey }
}

export const useResponsiveBgImage = (desktopUrl, mobileUrl) => {
	const bgImage = ref(`url('${mobileUrl}')`) // default mobile fallback

	onMounted(() => {
		const isDesktop = useMediaQuery('(min-width: 1024px)')

		bgImage.value = isDesktop.value
			? `url('${desktopUrl}')`
			: `url('${mobileUrl}')`

		watch(isDesktop, (val) => {
			bgImage.value = val ? `url('${desktopUrl}')` : `url('${mobileUrl}')`
		})
	})

	return { bgImage }
}
